import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { EloquaObjectDataset } from 'app/model/dataset/eloqua.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(EloquaObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class EloquaObjectDatasetAdapter extends TabularTypeDatasetAdapter<EloquaObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: EloquaObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(EloquaObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: EloquaObjectDataset): Promise<EloquaObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, EloquaObjectDataset.MODEL);
    }
}
